import type { UserResource } from "@clerk/nextjs/types";
import type { User } from "@clerk/nextjs/server";

export const updateUsersSavedFilters = async (
  savedFilters: SavedFilter[],
  user?: UserResource | null
) => {
  if (!user) {
    return;
  }

  user?.update({
    unsafeMetadata: { ...user.unsafeMetadata, savedFilters },
  });
};

export const updateUserFavorites = async (favorites: number[], user?: UserResource | null) => {
  if (!user) {
    return;
  }

  user?.update({
    unsafeMetadata: { ...user.unsafeMetadata, favorites },
  });
};

export const setMarketingConsent = async (marketingConsent: boolean, userId?: string | null) => {
  try {
    const response = await fetch("/api/user/setMarketingConsent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ marketingConsent, userId }),
    });

    return response.json();
  } catch (error) {
    const { logApiError } = await import("@/lib/client/errors");
    logApiError(error, "/api/user/setMarketingConsent", { userId });
  }
};

export const hasFreePro = (user?: User | UserResource | null) =>
  !!(user?.publicMetadata?.free_pro === true);
